import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

const RegistrationContext = createContext();

export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    throw new Error("useRegistration must be used within RegistrationProvider");
  }
  return context;
};

export const RegistrationProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    return localStorage.getItem("gym_owner_user_id") || null;
  });
  const [registrationData, setRegistrationData] = useState(null);

  useEffect(() => {
    if (userId) {
      localStorage.setItem("gym_owner_user_id", userId);
    } else {
      localStorage.removeItem("gym_owner_user_id");
    }
  }, [userId]);

  const saveUserId = (id) => {
    setUserId(id);
    localStorage.setItem("gym_owner_user_id", id);
  };

  const clearRegistration = () => {
    setUserId(null);
    setRegistrationData(null);
    localStorage.removeItem("gym_owner_user_id");
    Cookies.remove("gymify_web_security", { path: "/" });

  };

  return (
    <RegistrationContext.Provider
      value={{
        userId,
        saveUserId,
        registrationData,
        setRegistrationData,
        clearRegistration,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
};
